import { loginClient } from './login-client.js';
import Amplify, { Auth } from 'aws-amplify';
export { loginClient, Amplify, Auth };
